import LocalizedStrings from 'react-native-localization';
import moment from 'moment';
import { Platform } from 'react-native';
import generalLocalization from './general';
import accountLocalization from './account';
import appLocalization from './app';
import contentLocalization from './content';
import settingsLocalization from './settings';
import errorLocalization from './error';

class Localization {
  general = new LocalizedStrings(generalLocalization);
  account = new LocalizedStrings(accountLocalization);
  app = new LocalizedStrings(appLocalization);
  content = new LocalizedStrings(contentLocalization);
  settings = new LocalizedStrings(settingsLocalization);
  error = new LocalizedStrings(errorLocalization);

  getLanguage(): string {
    return this.general.getLanguage();
  }

  getInterfaceLanguage(): string {
    return this.general.getInterfaceLanguage();
  }

  setLanguage(language?: string): void {
    let localizationLanguage = language?.split('-')[0];
    localizationLanguage ??= this.getInterfaceLanguage().split('-')[0];

    const obj: any = this;
    for (const key of Object.keys(this)) {
      if (obj[key].setLanguage) {
        obj[key].setLanguage(localizationLanguage);
      }
    }

    if (Platform.OS === 'web') {
      moment.locale([language ?? '', localizationLanguage, 'en']);
      return;
    }

    const locales = moment.locales();
    let index = -1;
    if (language) index = locales.indexOf(language);
    if (index === -1) index = locales.indexOf(localizationLanguage);
    if (index === -1)
      index = locales.findIndex(e =>
        e.startsWith(localizationLanguage ?? 'en'),
      );
    moment.locale(index >= 0 ? locales[index] : 'en');
  }

  errCodeToMsg(code: number): string {
    if (code === -2) return this.error.networkError;
    const prop = `code${code}` as keyof typeof this.error;
    return this.error[prop]?.toString() ?? `${this.error.code0} (${code})`;
  }

  seasonsStr(n: number) {
    const lang = this.getInterfaceLanguage().split('-')[0];
    if (lang in numbersStr) return numbersStr[lang].seasons(n);
    return numbersStr.en.seasons(n);
  }
}

const numbersStr: { [key: string]: { [key: string]: (n: number) => string } } =
  {
    en: {
      seasons: (c: number) => {
        c = Math.floor(c);
        if (c > 1) return 'seasons';
        return 'season';
      },
    },
    ru: {
      seasons: (c: number) => {
        c = Math.floor(c);
        const n = c % 10;
        if (c >= 10 && c < 20) return 'сезонов';
        if (n === 1) return 'сезон';
        if (n >= 2 && n < 5) return 'сезона';
        return 'сезонов';
      },
    },
  };

const localization = new Localization();

export default localization;
